<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    html, body, #app, #app-layout {
        height: 100%;
        margin: 0;
    }

    body {
        display: flex;
        flex-direction: column;
    }

    nav.top-navigation {
        background-color: #FFFFFF;
        height: 75px;
        /*box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.1);*/
        box-shadow: none !important;
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;

        img.logo {
            margin: auto;
            margin-top: 26.5px;
            margin-bottom: 26.5px;
            width: 181px;
            display: block;
        }

        &:after {
            content: "";
            display: table;
            clear: both;
        }

        span.development-label {
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: #fff;
            background-color: #dc3545;
            padding: 0.25rem 0.875rem;
            border-radius: 5px;
            font-weight: bold;
            float: left;
            margin-top: 22px;
            margin-left: 10px;
        }
    }

    div#app-layout {
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }

        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }

        .grecaptcha-badge {
            visibility: hidden;
        }
    }

    div.container-lg {
        display: flex;
        margin-top: 75px;
        height: calc(100% - 75px);

        div.left-side {
            width: 50%;
            padding: 20px;
        }

        div.right-side {
            width: 50%;
            padding: 20px;
            background-color: #F9FAFC;

            span.services-label {
                display: block;
                font-family: 'Raleway', sans-serif;
                font-size: 20px;
                font-weight: bold;
                text-align: center;
                color: $regular-blue-color;
                margin: 0 auto !important;
            }

            div.swiper {
                display: none;
                width: 100%;
                height: 180px;

                div.swiper-slide {
                    display: flex;
                    /*justify-content: center;*/
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    height: 180px;
                }

                div.service-item {
                    .services-container-box {
                        height: 135px !important;
                    }

                    .services-container-icon {
                        margin-bottom: 0;
                    }
                }

                div.swiper-pagination {
                    span.swiper-pagination-bullet {
                        padding: 3px 18px;
                        border-radius: 0.5rem;
                        width: auto;
                        height: 6px;
                        opacity: 1;
                        background: rgba(0,0,0,0.2);
                    }

                    span.swiper-pagination-bullet-active {
                        background: $secondary-color;
                    }
                }
            }

            div.services-container {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(315px, 1fr));
                gap: 10px;
                /*max-width: 800px;*/
                width: 100%;
                margin-top: 20px;

                div.service-list-desktop {
                    display: contents;
                }

                div.services-container-box {
                    background: white;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    text-align: left;

                    display: flex;
                    align-items: flex-start;
                    gap: 10px;

                    div.services-container-icon {
                        font-size: 24px;
                        display: block;
                        margin-bottom: 10px;
                    }

                    div.services-container-content {
                        display: flex;
                        flex-direction: column;

                        p {
                            margin-left: -34px;
                            margin-bottom: 0;
                        }
                    }

                    a {
                        color: $secondary-color;
                        font-family: 'Raleway', sans-serif;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    p {
                        font-family: "Raleway", sans-serif;
                        font-size: 14px;
                        line-height: 1.5;
                    }

                    h3 {
                        margin-top: 0;
                        color: #222;
                        font-size: 16px;
                        font-weight: 500;
                        font-family: "Raleway", sans-serif;
                    }
                }
            }
        }
    }

    div.login-headline {
        width: 100%;
        /*max-width: 630px;*/
        min-width: 320px;
        padding: 5px;
        top: 200px;
        left: 50%;

        span.title {
            display: block;
            font-family: 'Raleway', sans-serif;
            font-size: 28px;
            font-weight: bold;
            text-align: center;
            color: $regular-blue-color;
            width: 380px;
            margin: 0 auto !important;
        }
    }

    div.license-plate-container-box {
        width: 360px;
        margin: 20px auto;

        .input-container {
            display: flex;
            align-items: center;
            border: 2px solid #ccc;
            border-radius: 8px;
            padding: 5px 5px;
            max-width: 400px;

            &.invalid {
                border: 2px solid #d0021b;
            }
        }

        .flag {
            background: #003399;
            color: white;
            padding: 5px 10px;
            border-radius: 4px;
            font-weight: bold;
            display: flex;
            align-items: center;
            gap: 5px;
            position: relative;

            &::after {
                content: "CZ";
                margin-left: -5px;
            }
        }

        .eu-container {
            display: flex;
            align-items: center;
        }

        .eu-circle {
            width: 30px;
            height: 30px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;
        }

        .star {
            position: absolute;
            color: gold;
            font-size: 5px;
        }

        .star:nth-child(1) { transform: rotate(0deg) translate(12px) rotate(0deg); }
        .star:nth-child(2) { transform: rotate(30deg) translate(12px) rotate(-30deg); }
        .star:nth-child(3) { transform: rotate(60deg) translate(12px) rotate(-60deg); }
        .star:nth-child(4) { transform: rotate(90deg) translate(12px) rotate(-90deg); }
        .star:nth-child(5) { transform: rotate(120deg) translate(12px) rotate(-120deg); }
        .star:nth-child(6) { transform: rotate(150deg) translate(12px) rotate(-150deg); }
        .star:nth-child(7) { transform: rotate(180deg) translate(12px) rotate(-180deg); }
        .star:nth-child(8) { transform: rotate(210deg) translate(12px) rotate(-210deg); }
        .star:nth-child(9) { transform: rotate(240deg) translate(12px) rotate(-240deg); }
        .star:nth-child(10) { transform: rotate(270deg) translate(12px) rotate(-270deg); }
        .star:nth-child(11) { transform: rotate(300deg) translate(12px) rotate(-300deg); }
        .star:nth-child(12) { transform: rotate(330deg) translate(12px) rotate(-330deg); }

        input {
            border: none;
            flex-grow: 1;
            font-size: 28px;
            line-height: 38px;
            padding: 3px;
            outline: none;
            text-transform: uppercase;
            margin: 0;
            box-shadow: none;
            color: #333333;
            background-color: #ffffff;
            font-family: "Raleway", sans-serif;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;

            &:focus {
                border: none;
                box-shadow: none;
            }
        }

        button.authorize-button {
            width: 255px !important;
        }
    }

    div.login-box {
        width: 100%;
        /*max-width: 630px;*/
        min-width: 320px;
        padding: 20px 10px;
        font-size: 16px;
        margin-top: 120px;

        div.login-label {
            color: #60636C;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            margin-top: 30px !important;
            margin-bottom: 30px !important;
            margin-left: auto !important;
            margin-right: auto !important;
            width: 380px;
        }

        span.title {
            display: block;
            font-family: 'Raleway', sans-serif;
            font-size: 32px;
            font-weight: bold;
            text-align: center;
            color: $regular-blue-color;
            width: 420px;
            margin: 0 auto !important;
        }

        div.license-plate-container {
            width: 260px;
            margin: 20px auto;
        }

        input.license-plate {
            color: #333333;
            background-color: #ffffff;
            background-image: url('/img/license-plate/cz.png');
            background-size: 24px;
            background-repeat: no-repeat;
            font-family: 'Raleway', sans-serif;
            font-size: 32px;
            line-height: 42px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            padding-left: 20px;
            width: 260px;
            height: 50px;
            border: 2px solid #333333;
            border-radius: 10px;
            outline: none;

            &:focus {
                border: 2px solid #333333;
            }

            &.invalid {
                border: 2px solid #d0021b;
            }

            &::placeholder {
                color: #d6d6d6;
            }
        }

        input.license-plate:-ms-input-placeholder { /* Internet Explorer 10+ */
            color: #eeeeee;
        }

        div.validation {
            color: #D0021B;
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            margin-top: 5px;
            margin-bottom: 5px;
            text-align: center;
        }

        p.learn-more-description {
            color: #666666;
            font-size: 13px;
            font-family: 'Raleway', sans-serif;
            text-align: center;
        }

        div.robot-recaptcha {
            text-align: center;
            margin-bottom: 1rem;
        }

        .g-recaptcha {
            display: inline-block;
        }

        button.authorize-button {
            border-radius: 5px;
            font-family: 'Raleway', sans-serif;
            color: white;
            width: 360px;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            padding: 10px;
            margin-top: 20px;
            display: block;
            margin: auto;
            outline:none;
            cursor: pointer;
            background-color: $secondary-color;
            transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            border: none;

            &:hover {
                background-color: #810050;
            }
        }

        .centered {
            margin: auto;
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        nav.top-navigation {
            img.logo {
                margin-top: 29.5px;
                margin-bottom: 29.5px;
                width: 150px;
            }

            span.development-label {
                display: none;
            }
        }

        div.container-lg {
            flex-direction: column;
            height: calc(100vh - 75px);

            div.left-side {
                width: 100%;
                padding: 10px;

                div.license-plate-container-box {
                    width: unset;
                }
            }

            div.right-side {
                width: 100%;
                padding: 10px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;

                div.service-list-desktop {
                    display: none !important;
                }
            }
        }

        div.login-headline {
            top: 215px;

            span.title {
                font-size: 28px;
            }
        }

        div.swiper {
            display: block !important;
        }

        div.login-box {
            /*width: 95%;*/
            top: 425px;
            padding: 0;
            margin-top: 0;

            div.login-label {
                margin-top: 15px !important;
                margin-bottom: 15px !important;
                width: unset;
            }

            span.title {
                font-size: 24px;
                width: 310px;
            }

            button.authorize-button {
                width: 300px;
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }

    /* iPad Pro 11-inch (Scaled Viewport - Landscape - Using ems) */
    @media screen and (min-width: 75em) and (max-width: 76.25em) and (orientation: landscape) {
        div.container-lg {
            div.right-side {
                div.services-container {
                    grid-template-columns: repeat(auto-fit, minmax(275px, 1fr)) !important;
                }
            }
        }
    }
</style>

<template>
    <div id="app-layout">
        <fullscreen-loader v-show="authorizeLoadStatus == 1" style="min-height: calc(100vh);"></fullscreen-loader>

        <transition name="fade">
            <flash-message v-show="flashMessage"/>
        </transition>

        <nav class="top-navigation">
            <div class="grid-x">
                <div class="large-4 medium-4 small-4 cell">
                    <span class="development-label" v-if="app_env == 'local' || app_env == 'development'">
                        Testovací prostředí
                    </span>
                </div>

                <div class="large-4 medium-4 small-4 cell">
                    <router-link :to="{ name: 'login'}">
                        <img src="/img/logo-navigation-drivalia.svg" class="logo" alt="Drivalia" />
                    </router-link>
                </div>

                <div class="large-4 medium-4 small-4 cell">
                    <lang-switcher />
                </div>
            </div>
        </nav>

        <router-view></router-view>

        <div class="container-lg">
            <div class="left-side">
                <form @submit.prevent="submitAuthorize">
                    <div class="login-box">
                        <span class="title" v-html="$t('general.applicationName')"></span>

                        <div class="login-label">{{ $t('auth.label') }}</div>

                        <!--
                        <div class="license-plate-container cell centered">
                            <input type="text" autocomplete="off" v-model="license_plate" v-bind:class="{ 'invalid' : !validations.license_plate.is_valid }" class="form-input license-plate" maxlength="9" placeholder="5A2 6125"/>
                            <div class="validation" v-show="!validations.license_plate.is_valid">{{ validations.license_plate.text }}</div>
                        </div>

                        <p class="learn-more-description">
                            {{ $t('auth.description') }}
                        </p>

                        <button type="submit" class="authorize-button">
                            {{ $t('auth.submitButton') }}
                        </button>
                        -->

                        <div class="license-plate-container-box cell centered">
                            <div class="input-container" v-bind:class="{ 'invalid' : !validations.license_plate.is_valid }">
                                <div class="flag">
                                    <div class="eu-container">
                                        <div class="eu-circle">
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                            <span class="star">★</span>
                                        </div>
                                    </div>
                                </div>
                                <input type="text" autocomplete="off" v-model="license_plate" class="form-input license-plateX" maxlength="9" placeholder="5A2 6125">

                                <button type="submit" class="authorize-button">
                                    {{ $t('auth.submitButton') }}
                                </button>
                            </div>

                            <div class="validation" style="height: 20px" v-bind:style="{ visibility: validations.license_plate.is_valid ? 'hidden' : 'visible' }">{{ validations.license_plate.text }}</div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="right-side">
                <span class="services-label" v-html="$t('general.servicesLabel')"></span>

                <div class="services-container">
                    <swiper class="swiper" :options="swiperOption">
                        <swiper-slide class="service-item">
                            <div class="services-container-box">
                                <i class="services-container-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.37878 3.96457L10.7072 6.29299C10.8947 6.48053 11.0001 6.73488 11.0001 7.0001V10.0001C11.0001 10.5524 10.5524 11.0001 10.0001 11.0001H7.0001C6.73488 11.0001 6.48053 10.8947 6.29299 10.7072L3.96456 8.37878C3.89135 8.89128 3.89773 9.41508 3.98632 9.93139C4.16116 10.9505 4.64765 11.8903 5.37878 12.6214C6.10991 13.3525 7.04972 13.839 8.0688 14.0139C9.08788 14.1887 10.1361 14.0433 11.0691 13.5977C11.4515 13.4151 11.9075 13.4933 12.2072 13.793L18.2072 19.793C18.4175 20.0033 18.7027 20.1214 19.0001 20.1214C19.2975 20.1214 19.5827 20.0033 19.793 19.793C20.0033 19.5827 20.1214 19.2975 20.1214 19.0001C20.1214 18.7027 20.0033 18.4175 19.793 18.2072L13.793 12.2072C13.4933 11.9075 13.4151 11.4515 13.5977 11.0691C14.0433 10.1361 14.1887 9.08788 14.0139 8.0688C13.839 7.04972 13.3525 6.10991 12.6214 5.37878C11.8903 4.64765 10.9505 4.16117 9.93139 3.98632C9.41508 3.89773 8.89128 3.89135 8.37878 3.96457ZM6.06913 2.59773C7.37537 1.97388 8.84288 1.77034 10.2696 2.01512C11.6963 2.25991 13.012 2.94098 14.0356 3.96456C15.0592 4.98815 15.7403 6.30388 15.9851 7.7306C16.189 8.91942 16.0817 10.1366 15.6793 11.2651L21.2072 16.793C21.7925 17.3784 22.1214 18.1723 22.1214 19.0001C22.1214 19.8279 21.7925 20.6218 21.2072 21.2072C20.6218 21.7926 19.8279 22.1214 19.0001 22.1214C18.1722 22.1214 17.3783 21.7926 16.793 21.2072L11.2651 15.6793C10.1365 16.0817 8.91942 16.189 7.7306 15.9851C6.30388 15.7403 4.98814 15.0592 3.96456 14.0356C2.94098 13.0121 2.25991 11.6963 2.01512 10.2696C1.77034 8.84288 1.97388 7.37537 2.59773 6.06913C2.73763 5.77619 3.01104 5.5694 3.33099 5.5145C3.65095 5.4596 3.97765 5.56344 4.2072 5.79299L7.41431 9.0001H9.0001V7.41431L5.79299 4.20721C5.56344 3.97765 5.4596 3.65096 5.5145 3.331C5.56939 3.01104 5.77619 2.73764 6.06913 2.59773Z" fill="#18305B"/>
                                    </svg>
                                </i>
                                <div class="services-container-content">
                                    <h3>{{ $t('general.maintenanceHeadline') }}</h3>
                                    <p v-html="$t('general.maintenanceDescription')"></p>
                                </div>
                            </div>
                        </swiper-slide>

                        <swiper-slide class="service-item">
                            <div class="services-container-box">
                                <i class="services-container-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#18305B"/>
                                        <circle cx="12" cy="12" r="2" stroke="#18305B" stroke-width="2"/>
                                        <circle cx="12" cy="12" r="6" stroke="#18305B" stroke-width="2"/>
                                        <line x1="12" y1="10" x2="12" y2="6" stroke="#18305B" stroke-width="2"/>
                                        <line x1="12" y1="18" x2="12" y2="14" stroke="#18305B" stroke-width="2"/>
                                        <line x1="6" y1="12" x2="10" y2="12" stroke="#18305B" stroke-width="2"/>
                                        <line x1="14" y1="12" x2="18" y2="12" stroke="#18305B" stroke-width="2"/>
                                    </svg>
                                </i>
                                <div class="services-container-content">
                                    <h3>{{ $t('general.tiresHeadline') }}</h3>
                                    <p v-html="$t('general.tiresDescription')"></p>
                                </div>
                            </div>
                        </swiper-slide>

                        <swiper-slide class="service-item">
                            <div class="services-container-box">
                                <i class="services-container-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 9.2929C16.0976 9.68343 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L8.29291 12.7071C7.90239 12.3166 7.90239 11.6834 8.29291 11.2929C8.68343 10.9024 9.3166 10.9024 9.70712 11.2929L11 12.5858L14.2929 9.2929C14.6834 8.90238 15.3166 8.90238 15.7071 9.2929Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6721 2.25938C12.5982 2.19219 12.5163 2.13789 12.4295 2.09667C12.2936 2.03194 12.1466 1.99995 12 2C11.8534 1.99995 11.7065 2.03194 11.5705 2.09667C11.4837 2.13789 11.4018 2.19219 11.328 2.25938C9.18803 4.1483 6.39745 5.13155 3.54573 5.00106C3.08555 4.98 2.67053 5.27602 2.54061 5.71798C2.04922 7.38958 1.89886 9.1429 2.09848 10.8738C2.29809 12.6046 2.8436 14.2777 3.70259 15.7936C4.56158 17.3094 5.71652 18.6371 7.09879 19.6978C8.48105 20.7585 10.0624 21.5305 11.7489 21.968C11.9136 22.0107 12.0864 22.0107 12.2511 21.968C13.9376 21.5305 15.519 20.7585 16.9012 19.6978C18.2835 18.6371 19.4385 17.3094 20.2974 15.7936C21.1564 14.2777 21.7019 12.6046 21.9016 10.8738C22.1012 9.1429 21.9508 7.38958 21.4594 5.71798C21.3295 5.27602 20.9145 4.98 20.4543 5.00106C17.6026 5.13155 14.812 4.1483 12.6721 2.25938ZM12 4.29725C9.78436 6.01038 7.07309 6.9626 4.27205 7.01065C4.00887 8.2015 3.94518 9.42961 4.08531 10.6446C4.25421 12.1092 4.7158 13.5249 5.44264 14.8075C6.16947 16.0902 7.14673 17.2136 8.31634 18.1112C9.4171 18.9558 10.6671 19.5841 12 19.9637C13.3329 19.5841 14.5829 18.9558 15.6837 18.1112C16.8533 17.2136 17.8306 16.0902 18.5574 14.8075C19.2842 13.5249 19.7458 12.1092 19.9147 10.6446C20.0548 9.42961 19.9912 8.2015 19.728 7.01065C16.9269 6.96259 14.2157 6.01038 12 4.29725Z" fill="#18305B"/>
                                    </svg>
                                </i>
                                <div class="services-container-content">
                                    <h3>{{ $t('general.damageHeadline') }}</h3>
                                    <p v-html="$t('general.damageDescription')"></p>
                                </div>
                            </div>
                        </swiper-slide>

                        <swiper-slide class="service-item">
                            <div class="services-container-box">
                                <i class="services-container-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 4C11.7349 4 11.4805 4.10536 11.293 4.29289C11.1092 4.47674 11.0043 4.72479 11.0002 4.98434C11.0032 5.17963 10.9485 5.37135 10.845 5.53509C10.7699 5.65398 10.669 5.75812 10.5457 5.83816C10.5024 5.86646 10.4566 5.89148 10.4089 5.91287C9.43263 6.37863 8.60026 7.09974 8.00009 8C7.40028 8.89972 7.05483 9.94469 7.00009 11.0244V14C7.00009 14.0402 6.99767 14.0803 6.99284 14.1202C6.91259 14.7832 6.70049 15.4222 6.3703 16H17.6299C17.2997 15.4222 17.0876 14.7832 17.0073 14.1202C17.0025 14.0803 17.0001 14.0402 17.0001 14V11.0244C16.9454 9.9447 16.5999 8.89972 16.0001 8C15.3961 7.09402 14.557 6.36948 13.5726 5.90403C13.223 5.73873 13.0001 5.38669 13.0001 5C13.0001 4.73478 12.8947 4.48043 12.7072 4.29289C12.5197 4.10536 12.2653 4 12.0001 4ZM9.07008 4.35572C9.19216 3.80059 9.47057 3.28688 9.87877 2.87868C10.4414 2.31607 11.2045 2 12.0001 2C12.7957 2 13.5588 2.31607 14.1214 2.87868C14.5296 3.28688 14.808 3.80059 14.9301 4.35572C16.0261 4.97224 16.9637 5.83991 17.6642 6.8906C18.4695 8.09857 18.9309 9.50291 18.999 10.9531C18.9997 10.9687 19.0001 10.9844 19.0001 11V13.9354C19.0626 14.3815 19.2248 14.8082 19.475 15.1834C19.7355 15.5742 20.0841 15.8984 20.4929 16.1298C20.888 16.3536 21.0828 16.8156 20.9671 17.2548C20.8514 17.694 20.4543 18 20.0001 18H4.00009C3.54593 18 3.14881 17.694 3.03309 17.2548C2.91738 16.8156 3.11214 16.3536 3.50734 16.1298C3.91604 15.8984 4.26469 15.5742 4.52523 15.1834C4.7754 14.8082 4.93761 14.3815 5.00009 13.9353V11C5.00009 10.9844 5.00046 10.9687 5.00119 10.9531C5.06926 9.50291 5.53068 8.09857 6.33599 6.8906C7.03645 5.83991 7.97412 4.97224 9.07008 4.35572Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 16C9.55228 16 10 16.4477 10 17V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 19.0609 15.5786 20.0783 14.8284 20.8284C14.0783 21.5786 13.0609 22 12 22C10.9391 22 9.92172 21.5786 9.17157 20.8284C8.42143 20.0783 8 19.0609 8 18V17C8 16.4477 8.44772 16 9 16Z" fill="#18305B"/>
                                    </svg>
                                </i>
                                <div class="services-container-content">
                                    <h3>{{ $t('general.callingActionHeadline') }}</h3>
                                    <p v-html="$t('general.callingActionDescription')"></p>
                                </div>
                            </div>
                        </swiper-slide>

                        <swiper-slide class="service-item">
                            <div class="services-container-box">
                                <i class="services-container-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V16C21 16.663 20.7366 17.2989 20.2678 17.7678C19.7989 18.2366 19.163 18.5 18.5 18.5C17.837 18.5 17.2011 18.2366 16.7322 17.7678C16.2634 17.2989 16 16.663 16 16V13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H14C13.4477 12 13 11.5523 13 11C13 10.4477 13.4477 10 14 10H15C15.7957 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2043 18 13V16C18 16.1326 18.0527 16.2598 18.1464 16.3536C18.2402 16.4473 18.3674 16.5 18.5 16.5C18.6326 16.5 18.7598 16.4473 18.8536 16.3536C18.9473 16.2598 19 16.1326 19 16V9.41421L16.2929 6.70711C15.9024 6.31658 15.9024 5.68342 16.2929 5.29289Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H12C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6V20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5H6Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5145 10.6425C9.98808 10.9267 10.1416 11.5409 9.85749 12.0145L9.26619 13H10.5C10.8603 13 11.1927 13.1938 11.3702 13.5073C11.5477 13.8208 11.5429 14.2056 11.3575 14.5145L9.85749 17.0145C9.57334 17.4881 8.95908 17.6417 8.4855 17.3575C8.01192 17.0734 7.85836 16.4591 8.14251 15.9855L8.73381 15H7.5C7.13973 15 6.80731 14.8062 6.6298 14.4927C6.45229 14.1792 6.45715 13.7945 6.64251 13.4855L8.14251 10.9855C8.42666 10.512 9.04092 10.3584 9.5145 10.6425Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 20C2 19.4477 2.44772 19 3 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H3C2.44772 21 2 20.5523 2 20Z" fill="#18305B"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 8C3 7.44772 3.44772 7 4 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H4C3.44772 9 3 8.55228 3 8Z" fill="#18305B"/>
                                    </svg>
                                </i>
                                <div class="services-container-content">
                                    <h3>{{ $t('general.chargingStationHeadline') }}</h3>
                                    <p v-html="$t('general.chargingStationDescription')"></p>
                                </div>
                            </div>
                        </swiper-slide>

                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>

                    <div class="service-list-desktop">
                        <div class="services-container-box">
                            <i class="services-container-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.37878 3.96457L10.7072 6.29299C10.8947 6.48053 11.0001 6.73488 11.0001 7.0001V10.0001C11.0001 10.5524 10.5524 11.0001 10.0001 11.0001H7.0001C6.73488 11.0001 6.48053 10.8947 6.29299 10.7072L3.96456 8.37878C3.89135 8.89128 3.89773 9.41508 3.98632 9.93139C4.16116 10.9505 4.64765 11.8903 5.37878 12.6214C6.10991 13.3525 7.04972 13.839 8.0688 14.0139C9.08788 14.1887 10.1361 14.0433 11.0691 13.5977C11.4515 13.4151 11.9075 13.4933 12.2072 13.793L18.2072 19.793C18.4175 20.0033 18.7027 20.1214 19.0001 20.1214C19.2975 20.1214 19.5827 20.0033 19.793 19.793C20.0033 19.5827 20.1214 19.2975 20.1214 19.0001C20.1214 18.7027 20.0033 18.4175 19.793 18.2072L13.793 12.2072C13.4933 11.9075 13.4151 11.4515 13.5977 11.0691C14.0433 10.1361 14.1887 9.08788 14.0139 8.0688C13.839 7.04972 13.3525 6.10991 12.6214 5.37878C11.8903 4.64765 10.9505 4.16117 9.93139 3.98632C9.41508 3.89773 8.89128 3.89135 8.37878 3.96457ZM6.06913 2.59773C7.37537 1.97388 8.84288 1.77034 10.2696 2.01512C11.6963 2.25991 13.012 2.94098 14.0356 3.96456C15.0592 4.98815 15.7403 6.30388 15.9851 7.7306C16.189 8.91942 16.0817 10.1366 15.6793 11.2651L21.2072 16.793C21.7925 17.3784 22.1214 18.1723 22.1214 19.0001C22.1214 19.8279 21.7925 20.6218 21.2072 21.2072C20.6218 21.7926 19.8279 22.1214 19.0001 22.1214C18.1722 22.1214 17.3783 21.7926 16.793 21.2072L11.2651 15.6793C10.1365 16.0817 8.91942 16.189 7.7306 15.9851C6.30388 15.7403 4.98814 15.0592 3.96456 14.0356C2.94098 13.0121 2.25991 11.6963 2.01512 10.2696C1.77034 8.84288 1.97388 7.37537 2.59773 6.06913C2.73763 5.77619 3.01104 5.5694 3.33099 5.5145C3.65095 5.4596 3.97765 5.56344 4.2072 5.79299L7.41431 9.0001H9.0001V7.41431L5.79299 4.20721C5.56344 3.97765 5.4596 3.65096 5.5145 3.331C5.56939 3.01104 5.77619 2.73764 6.06913 2.59773Z" fill="#18305B"/>
                                </svg>
                            </i>
                            <div class="services-container-content">
                                <h3>{{ $t('general.maintenanceHeadline') }}</h3>
                                <p v-html="$t('general.maintenanceDescription')"></p>
                            </div>
                        </div>

                        <div class="services-container-box">
                            <i class="services-container-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 4C11.7349 4 11.4805 4.10536 11.293 4.29289C11.1092 4.47674 11.0043 4.72479 11.0002 4.98434C11.0032 5.17963 10.9485 5.37135 10.845 5.53509C10.7699 5.65398 10.669 5.75812 10.5457 5.83816C10.5024 5.86646 10.4566 5.89148 10.4089 5.91287C9.43263 6.37863 8.60026 7.09974 8.00009 8C7.40028 8.89972 7.05483 9.94469 7.00009 11.0244V14C7.00009 14.0402 6.99767 14.0803 6.99284 14.1202C6.91259 14.7832 6.70049 15.4222 6.3703 16H17.6299C17.2997 15.4222 17.0876 14.7832 17.0073 14.1202C17.0025 14.0803 17.0001 14.0402 17.0001 14V11.0244C16.9454 9.9447 16.5999 8.89972 16.0001 8C15.3961 7.09402 14.557 6.36948 13.5726 5.90403C13.223 5.73873 13.0001 5.38669 13.0001 5C13.0001 4.73478 12.8947 4.48043 12.7072 4.29289C12.5197 4.10536 12.2653 4 12.0001 4ZM9.07008 4.35572C9.19216 3.80059 9.47057 3.28688 9.87877 2.87868C10.4414 2.31607 11.2045 2 12.0001 2C12.7957 2 13.5588 2.31607 14.1214 2.87868C14.5296 3.28688 14.808 3.80059 14.9301 4.35572C16.0261 4.97224 16.9637 5.83991 17.6642 6.8906C18.4695 8.09857 18.9309 9.50291 18.999 10.9531C18.9997 10.9687 19.0001 10.9844 19.0001 11V13.9354C19.0626 14.3815 19.2248 14.8082 19.475 15.1834C19.7355 15.5742 20.0841 15.8984 20.4929 16.1298C20.888 16.3536 21.0828 16.8156 20.9671 17.2548C20.8514 17.694 20.4543 18 20.0001 18H4.00009C3.54593 18 3.14881 17.694 3.03309 17.2548C2.91738 16.8156 3.11214 16.3536 3.50734 16.1298C3.91604 15.8984 4.26469 15.5742 4.52523 15.1834C4.7754 14.8082 4.93761 14.3815 5.00009 13.9353V11C5.00009 10.9844 5.00046 10.9687 5.00119 10.9531C5.06926 9.50291 5.53068 8.09857 6.33599 6.8906C7.03645 5.83991 7.97412 4.97224 9.07008 4.35572Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 16C9.55228 16 10 16.4477 10 17V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 19.0609 15.5786 20.0783 14.8284 20.8284C14.0783 21.5786 13.0609 22 12 22C10.9391 22 9.92172 21.5786 9.17157 20.8284C8.42143 20.0783 8 19.0609 8 18V17C8 16.4477 8.44772 16 9 16Z" fill="#18305B"/>
                                </svg>
                            </i>
                            <div class="services-container-content">
                                <h3>{{ $t('general.callingActionHeadline') }}</h3>
                                <p v-html="$t('general.callingActionDescription')"></p>
                          </div>
                        </div>

                        <div class="services-container-box">
                            <i class="services-container-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#18305B"/>
                                    <circle cx="12" cy="12" r="2" stroke="#18305B" stroke-width="2"/>
                                    <circle cx="12" cy="12" r="6" stroke="#18305B" stroke-width="2"/>
                                    <line x1="12" y1="10" x2="12" y2="6" stroke="#18305B" stroke-width="2"/>
                                    <line x1="12" y1="18" x2="12" y2="14" stroke="#18305B" stroke-width="2"/>
                                    <line x1="6" y1="12" x2="10" y2="12" stroke="#18305B" stroke-width="2"/>
                                    <line x1="14" y1="12" x2="18" y2="12" stroke="#18305B" stroke-width="2"/>
                                </svg>
                            </i>
                            <div class="services-container-content">
                                <h3>{{ $t('general.tiresHeadline') }}</h3>
                                <p v-html="$t('general.tiresDescription')"></p>
                            </div>
                        </div>

                        <div class="services-container-box">
                            <i class="services-container-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V16C21 16.663 20.7366 17.2989 20.2678 17.7678C19.7989 18.2366 19.163 18.5 18.5 18.5C17.837 18.5 17.2011 18.2366 16.7322 17.7678C16.2634 17.2989 16 16.663 16 16V13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H14C13.4477 12 13 11.5523 13 11C13 10.4477 13.4477 10 14 10H15C15.7957 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2043 18 13V16C18 16.1326 18.0527 16.2598 18.1464 16.3536C18.2402 16.4473 18.3674 16.5 18.5 16.5C18.6326 16.5 18.7598 16.4473 18.8536 16.3536C18.9473 16.2598 19 16.1326 19 16V9.41421L16.2929 6.70711C15.9024 6.31658 15.9024 5.68342 16.2929 5.29289Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H12C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6V20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5H6Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5145 10.6425C9.98808 10.9267 10.1416 11.5409 9.85749 12.0145L9.26619 13H10.5C10.8603 13 11.1927 13.1938 11.3702 13.5073C11.5477 13.8208 11.5429 14.2056 11.3575 14.5145L9.85749 17.0145C9.57334 17.4881 8.95908 17.6417 8.4855 17.3575C8.01192 17.0734 7.85836 16.4591 8.14251 15.9855L8.73381 15H7.5C7.13973 15 6.80731 14.8062 6.6298 14.4927C6.45229 14.1792 6.45715 13.7945 6.64251 13.4855L8.14251 10.9855C8.42666 10.512 9.04092 10.3584 9.5145 10.6425Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 20C2 19.4477 2.44772 19 3 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H3C2.44772 21 2 20.5523 2 20Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 8C3 7.44772 3.44772 7 4 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H4C3.44772 9 3 8.55228 3 8Z" fill="#18305B"/>
                                </svg>
                            </i>
                            <div class="services-container-content">
                                <h3>{{ $t('general.chargingStationHeadline') }}</h3>
                                <p v-html="$t('general.chargingStationDescription')"></p>
                            </div>
                        </div>

                        <div class="services-container-box">
                            <i class="services-container-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 9.2929C16.0976 9.68343 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L8.29291 12.7071C7.90239 12.3166 7.90239 11.6834 8.29291 11.2929C8.68343 10.9024 9.3166 10.9024 9.70712 11.2929L11 12.5858L14.2929 9.2929C14.6834 8.90238 15.3166 8.90238 15.7071 9.2929Z" fill="#18305B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6721 2.25938C12.5982 2.19219 12.5163 2.13789 12.4295 2.09667C12.2936 2.03194 12.1466 1.99995 12 2C11.8534 1.99995 11.7065 2.03194 11.5705 2.09667C11.4837 2.13789 11.4018 2.19219 11.328 2.25938C9.18803 4.1483 6.39745 5.13155 3.54573 5.00106C3.08555 4.98 2.67053 5.27602 2.54061 5.71798C2.04922 7.38958 1.89886 9.1429 2.09848 10.8738C2.29809 12.6046 2.8436 14.2777 3.70259 15.7936C4.56158 17.3094 5.71652 18.6371 7.09879 19.6978C8.48105 20.7585 10.0624 21.5305 11.7489 21.968C11.9136 22.0107 12.0864 22.0107 12.2511 21.968C13.9376 21.5305 15.519 20.7585 16.9012 19.6978C18.2835 18.6371 19.4385 17.3094 20.2974 15.7936C21.1564 14.2777 21.7019 12.6046 21.9016 10.8738C22.1012 9.1429 21.9508 7.38958 21.4594 5.71798C21.3295 5.27602 20.9145 4.98 20.4543 5.00106C17.6026 5.13155 14.812 4.1483 12.6721 2.25938ZM12 4.29725C9.78436 6.01038 7.07309 6.9626 4.27205 7.01065C4.00887 8.2015 3.94518 9.42961 4.08531 10.6446C4.25421 12.1092 4.7158 13.5249 5.44264 14.8075C6.16947 16.0902 7.14673 17.2136 8.31634 18.1112C9.4171 18.9558 10.6671 19.5841 12 19.9637C13.3329 19.5841 14.5829 18.9558 15.6837 18.1112C16.8533 17.2136 17.8306 16.0902 18.5574 14.8075C19.2842 13.5249 19.7458 12.1092 19.9147 10.6446C20.0548 9.42961 19.9912 8.2015 19.728 7.01065C16.9269 6.96259 14.2157 6.01038 12 4.29725Z" fill="#18305B"/>
                                </svg>
                            </i>
                            <div class="services-container-content">
                                <h3>{{ $t('general.damageHeadline') }}</h3>
                                <p v-html="$t('general.damageDescription')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vue-recaptcha ref="recaptcha" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" class="g-recaptcha" :sitekey="recaptcha_sitekey" size="invisible" :loadRecaptchaScript="true" :language="$i18n.locale"></vue-recaptcha>

        <type-modal></type-modal>

        <cancel-scenario-modal :show="showCancelScenarioModal" :cancel-token="$route.query.st" @close-modal="closeCancelScenarioModal" />
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { ROAST_CONFIG } from '../config.js';
    import { EventBus } from '../event-bus.js';
    import API from "../api/service.js";
    import FullscreenLoader from "../components/global/FullscreenLoader";
    import FlashMessage from '../components/global/FlashMessage.vue'
    import LangSwitcher from "../components/global/LangSwitcher.vue";
    import TypeModal from '../components/global/TypeModal.vue';
    import CancelScenarioModal from '../components/global/CancelScenarioModal.vue';
    import VueRecaptcha from 'vue-recaptcha';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import 'swiper/css/swiper.css';

    export default {
        components: {
            FullscreenLoader,
            FlashMessage,
            LangSwitcher,
            TypeModal,
            CancelScenarioModal,
            VueRecaptcha,
            Swiper,
            SwiperSlide
        },

        data() {
            return {
                showCancelScenarioModal: false,

                license_plate: '',

                swiperOption: {
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 4500,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        renderBullet(index, className) {
                            return '<span class="' + className + '"></span>';
                        }
                    }
                },

                recaptcha_sitekey: ROAST_CONFIG.GOOGLE_RECAPTCHA_SITEKEY,

                app_env: ROAST_CONFIG.APP_ENV,

                validations: {
                    license_plate: {
                        is_valid: true,
                        text: ''
                    }
                }
            }
        },

        computed: {
            ...mapState({
                flashMessage: state => state.flashMessage.data.show
            }),

            authorizeLoadStatus() {
                return this.$store.getters.getAuthorizeLoadStatus;
            },
        },

        created() {
            if (this.$route.query.st && !this.$route.query.yourPassId) {
                this.showCancelScenarioModal = true;
            }

            if (this.$route.query.returnWithInspector) {
                this.authorizeReturnWithInspector();
            }

            if (this.$route.query.yourPassId) {
                this.authorizeYourPassId();
            }
        },

        mounted() {
            //this.license_plate = '4AU 9976';
        },

        watch: {
            '$route' (to, from) {
                if (to.query.st && !to.query.yourPassId) {
                    this.showCancelScenarioModal = true;
                }

                if (to.query.returnWithInspector) {
                    this.authorizeReturnWithInspector();
                }

                if (to.query.yourPassId) {
                    this.authorizeYourPassId();
                }
            },
        },

        methods: {
            closeCancelScenarioModal() {
                this.showCancelScenarioModal = false;

                const query = { ...this.$route.query };
                delete query.st;
                this.$router.replace({ query });
            },

            submitAuthorize() {
                if (this.validateAuthorize()) {
                    this.$refs.recaptcha.execute();
                }
            },

            validateAuthorize() {
                let validOrderServiceForm = true;

                if (this.license_plate.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.license_plate.is_valid = false;
                    this.validations.license_plate.text = this.$t('auth.validationLicensePlate');
                } else {
                    this.validations.license_plate.is_valid = true;
                    this.validations.license_plate.text = '';
                }

                return validOrderServiceForm;
            },

            onVerifyRecaptcha: function (response) {
                if (response) {
                    this.$store.commit('setAuthorizeLoadStatus', 1);

                    localStorage.clear();

                    this.$store.commit('setDistanceFilter', 10);
                    this.$store.commit('setClientCurrentLocation', '');
                    this.$store.commit('setServices', []);
                    this.$store.commit('setLicensePlate', null);
                    this.$store.commit('setClientPersonalData', null);

                    API.postAuthorize(this.license_plate)
                        .then((response) => {
                            if (response.status === 200) {
                                this.$store.commit('setAuthorizeLoadStatus', 2);

                                EventBus.$emit('prompt-type', response);
                            }
                        })
                        .catch((error) => {
                            this.$store.commit('setAuthorizeLoadStatus', 2);

                            this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                        });

                    this.$refs.recaptcha.reset();
                }
            },

            onExpiredRecaptcha: function () {
                this.$refs.recaptcha.reset();
            },

            authorizeReturnWithInspector() {
                this.$store.commit('setAuthorizeLoadStatus', 1);

                //localStorage.clear();

                //this.$store.commit('setDistanceFilter', 10);
                //this.$store.commit('setClientCurrentLocation', '');
                //this.$store.commit('setServices', []);
                //this.$store.commit('setLicensePlate', null);
                //this.$store.commit('setClientPersonalData', response.data);

                API.postAuthorize(this.$route.query.returnWithInspector)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$store.commit('setAuthorizeLoadStatus', 2);

                            localStorage.removeItem('make_id');
                            this.$store.commit('setMakeId', null);
                            this.$store.commit('setDistanceFilter', 350);

                            return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                                return this.$store.dispatch('setWorkroom', 860).then(() => {
                                    return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                                        return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                                            return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                                if (this.$router.currentRoute.name == 'services' || this.$router.currentRoute.name == 'service') {
                                                    window.location.reload();
                                                } else {
                                                    return this.$router.push(this.$route.params.onLogin || '/');
                                                }
                                            });
                                        }, () => {});
                                    }, () => {});
                                }, () => {});
                            }, () => {});
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('setAuthorizeLoadStatus', 2);

                        this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                    });
            },

            authorizeYourPassId() {
                API.postYourPassData(this.$route.query.yourPassId)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$store.commit('setAuthorizeLoadStatus', 1);

                            localStorage.clear();

                            this.$store.commit('setDistanceFilter', 10);
                            this.$store.commit('setClientCurrentLocation', '');
                            this.$store.commit('setServices', []);
                            this.$store.commit('setLicensePlate', null);
                            this.$store.commit('setClientPersonalData', response.data);

                            API.postAuthorize(response.data.license_plate)
                                .then((response) => {
                                    if (response.status === 200) {

                                        if (this.$route.query.type == 'maintenance' || this.$route.query['amp;type'] == 'maintenance') {
                                            if (response.data.maintenance_included == true) {

                                                this.$store.commit('setAuthorizeLoadStatus', 2);

                                                localStorage.removeItem('make_id');
                                                this.$store.commit('setMakeId', null);
                                                this.$store.commit('setDistanceFilter', 10);

                                                return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                                                    return this.$store.dispatch('setWorkroom', 20).then(() => {
                                                        return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                                                            return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                                                                return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                                                    if (this.$router.currentRoute.name == 'services' || this.$router.currentRoute.name == 'service') {
                                                                        window.location.reload();
                                                                    } else {
                                                                        const redirectPath = this.$route.params.onLogin || '/';
                                                                        const queryParams = {};

                                                                        if (this.$route.query.st) {
                                                                            queryParams.st = this.$route.query.st;
                                                                        }

                                                                        return this.$router.push({ path: redirectPath, query: queryParams });
                                                                    }
                                                                });
                                                            }, () => {});
                                                        }, () => {});
                                                    }, () => {});
                                                }, () => {});
                                            } else {
                                                this.$store.commit('setAuthorizeLoadStatus', 2);

                                                this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorNoMaintenance') }, { root: true })
                                            }
                                        } else if (this.$route.query.type == 'tires' || this.$route.query['amp;type'] == 'tires') {
                                            this.$store.commit('setAuthorizeLoadStatus', 2);

                                            localStorage.removeItem('make_id');
                                            this.$store.commit('setMakeId', null);
                                            this.$store.commit('setDistanceFilter', 10);

                                            return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                                                return this.$store.dispatch('setWorkroom', 60).then(() => {
                                                    return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                                                        return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                                                            return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                                                if (this.$router.currentRoute.name == 'services' || this.$router.currentRoute.name == 'service') {
                                                                    window.location.reload();
                                                                } else {
                                                                    return this.$router.push(this.$route.params.onLogin || '/');
                                                                }
                                                            });
                                                        }, () => {});
                                                    }, () => {});
                                                }, () => {});
                                            }, () => {});
                                        } else {
                                            this.$store.commit('setAuthorizeLoadStatus', 2);

                                            EventBus.$emit('prompt-type', response);
                                        }
                                    }
                                })
                                .catch((error) => {
                                    this.$store.commit('setAuthorizeLoadStatus', 2);

                                    this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                                });
                        }
                    })
                    .catch((error) => {
                        //
                    });
            },
        }
    }
</script>
